import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { SectorService } from '@/infra/services/sector';
import type { SelectOption } from '@/components/ui/SelectOptions/types';

interface GetSectorsParams {
	organization_id: string;
	company_id: string;
}

const Service = SectorService.getInstance();

export const useGetSectors = (params: GetSectorsParams) => {
	return useQuery<SelectOption[]>({
		queryKey: [QUERY_KEYS.GET_SECTORS, params],
		queryFn: async () => Service.getSectors(params),
		enabled: !!params.organization_id && !!params.company_id
	});
};
